if ($(window).width() < 768) {  
$('div#shopify-section-16228040310e647de7 .grid.grid--uniform.grid--flush-bottom').slick({
  dots: true,
  infinite: true,
  prevArrow: false,
  nextArrow: false,
  autoplay: true,
  autoplaySpeed: 3000
});
  
$('.community-block .flex').slick({
  centerMode: true,
  centerPadding: '60px',
  slidesToShow: 1, 
  infinite: true,
  prevArrow: false,
  nextArrow: false,
  autoplay: true,
  autoplaySpeed: 3000
});  
}

$(document).ready(function () {
  let first_level_nav = false;
  let second_level_nav = false;
  $(document).on('click', '.site-navigation .site-nav__item', function (f) {
    if(first_level_nav == false){
      first_level_nav = true;
      $(this).addClass('nav_active_focus');
      $(this).find('.first-level-active, .chev-side').attr("aria-expanded","true");
      $(this).find('.custome-ul, .thedrmenu').addClass('nav_active_focus');
    }else{
      first_level_nav = false;
      $(this).removeClass('nav_active_focus');
      $(this).find('.first-level-active, .chev-side').attr("aria-expanded","false");
      $(this).find('.custome-ul, .thedrmenu').removeClass('nav_active_focus');
    }
    
  });

  $(document).on("click", ".custome-ul li .second-level", function (e) {

    if(second_level_nav == false){
      second_level_nav = true;
      // Find and remove 'mega-menu-open' class from the currently open .third-menu-div
      $(this).closest('.custome-ul').find('.third-menu-div.mega-menu-open').removeClass('mega-menu-open');
      $(this).attr("aria-expanded","true");
      // Add 'mega-menu-open' class to the current clicked element's sibling .third-menu-div
      $(this).siblings('.third-menu-div').addClass('mega-menu-open');
      // Remove 'nav_active_focus' class from the current li
      $(this).parent().removeClass('nav_active_focus');
    }else{
      second_level_nav = false;
      $(this).closest('.custome-ul').find('.third-menu-div.mega-menu-open').removeClass('mega-menu-open');
      $(this).attr("aria-expanded","false");
      // Add 'mega-menu-open' class to the current clicked element's sibling .third-menu-div
      $(this).siblings('.third-menu-div').removeClass('mega-menu-open');
      // Remove 'nav_active_focus' class from the current li
      $(this).parent().removeClass('nav_active_focus');
    }

  });

  $(document).on('focusout', '.thedrmenu div:last-of-type li > a', function () {
    $(this).parents().find('.thedrmenu').removeClass('nav_active_focus');
    $(this).find('button').attr("aria-expanded","false");
    first_level_nav = false;
  });

  $(document).on('focusout', '.custome-ul li:last-of-type > button', function () {
    $(this).parents().find('.custome-ul').removeClass('nav_active_focus');
    $(this).parents().find('.first-level-active, .chev-side').attr("aria-expanded","false");
    first_level_nav = false;
  });

  $(document).on('focusout', '.promotion-grandchild-links', function () {
    $(this).parents().find('.third-menu-div').removeClass('mega-menu-open');
    $(this).parents().find('.custome-ul .nav_active_focus').removeClass('nav_active_focus');
    $(this).parents().find('.second-level').attr("aria-expanded","false");
    $(this).parents().find('.first-level-active').removeClass('nav_active_focus');
    second_level_nav = false;
  });
  $('.js-drawer-open-nav.medium-up--hide').removeAttr('aria-expanded');
  $('.js-drawer-open-nav.medium-up--hide').on('click', function () {
    if ($(this).attr('aria-expanded')) {
      $(this).removeAttr('aria-expanded');
    }
  });
  let mobile_menu_is_open = false;
  const menu_button = document.querySelector('.js-drawer-open-nav.medium-up--hide');
  if(menu_button.length > 0){
    menu_button.addEventListener('click',function(){
      if(!mobile_menu_is_open){
        menu_button.focus();
        mobile_menu_is_open = true
      }
      else{
        mobile_menu_is_open = false;
      }
    });
  }
  


  var dialog_nav_drawer = document.getElementById('NavDrawer');
  var firstFocusableElement_nav_drawer = dialog_nav_drawer.querySelector('.site-header__search-btn--submit');
  var lastFocusableElement_nav_drawer = dialog_nav_drawer.querySelector('.nav-last-div > button');

  dialog_nav_drawer.addEventListener('keydown', function(e) {
    if(dialog_nav_drawer.querySelector('.nav-last-div > button.is-open')){
      let last_div = dialog_nav_drawer.querySelectorAll('.last_element_drawer');
      if (last_div.length > 0) {
        let lastElement = last_div[last_div.length - 1];
        lastFocusableElement_nav_drawer = lastElement; 
      }
    }else{
      lastFocusableElement_nav_drawer = dialog_nav_drawer.querySelector('.nav-last-div > button');
    }
    if(e.target == firstFocusableElement_nav_drawer && e.key == 'Tab' && e.shiftKey) {
      e.preventDefault();
      menu_button.focus()
    } else if(e.target == lastFocusableElement_nav_drawer && e.key == 'Tab' && !e.shiftKey) {
      e.preventDefault();
      firstFocusableElement_nav_drawer.focus();
    }
  });

});

